import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { AppRoutingModule, routingComponents } from './app-routing.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';
import { NavComponent } from './nav/nav.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HomeComponent } from './home/home.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthService } from './services/auth.service';
import { AuthGuard } from './auth.guard';
import { LogoutComponent } from './logout/logout.component';
import {JwtModule} from '@auth0/angular-jwt';
import { AuthInterceptor } from './auth-interceptor';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { TccReportsComponent } from './tcc-reports/tcc-reports.component';
import { EmailComponent } from './email/email.component';
import { PurposeComponent } from './purpose/purpose.component';
import { DataTablesModule } from 'angular-datatables';


export function tokenGettenFn(){
  const token = localStorage.getItem('token');
  if(token===null){
    return "";
  }
  else{
    return token;
  }
};

@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    routingComponents,
    PageNotFoundComponent,
    HomeComponent,
    //TccAdminComponent,
    LogoutComponent,
    ResetPasswordComponent,
    TccReportsComponent,
    EmailComponent,
    PurposeComponent,
    //DownloadTccCertComponent,
    //TrackingComponent,
    //TaxpayerDocumentComponent,
    //UploadDocComponent
    // TccDetailComponent,
    // CommentComponent,
    // PaymentHistoryComponent,
    // AssessmentHistoryComponent,
    // FilingHistoryComponent,
    // AssignOfficerComponent,
    // QueryRequestComponent
  ],
  imports: [
    BrowserModule,
    PdfViewerModule,
    AppRoutingModule,
    FormsModule,
    NgbModule,
    DataTablesModule,
    ReactiveFormsModule,
    HttpClientModule,
    JwtModule.forRoot({
      config:{
        tokenGetter: tokenGettenFn
      }
    })
  ],
  providers: [
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    }
  
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
